import { httpClient } from '../http/httpClient'

export interface RelationshipDegree {
  id: number
  nome: string
}

export interface RelationshipDegreeResponse {
  data: RelationshipDegree[]
}

export async function getRelationshipDegree() {
  const { data } = await httpClient.get<RelationshipDegreeResponse>(
    '/self-hire/context/tipoReferencia',
  )
  return data
}
